import { API } from './api';
import { IConfig } from '../pages/notifications/types';
import { GW_SERVICES_PREFIXES } from 'app/constants/gateway';

const { INTERNAL } = GW_SERVICES_PREFIXES;

/* Получение текущих настроек оповещений */
export const getCurrentConfig = (params?: {
  tenant_id: string;
}): Promise<IConfig> =>
  API.get(`/${INTERNAL}/api/v4/notifications/refusal/config/`, params);

/* Изменение текущих настроек оповещений */
export const changeConfig = (data: {
  tenant_id?: string;
  email: boolean;
  mobile_app: boolean;
  telegram: boolean;
  max_bot: boolean;
  vk: boolean;
}) => API.post(`/${INTERNAL}/api/v4/notifications/refusal/channels/`, data);

/* Перенос адреса пользователя в архив и отказ от оповещений */
export const sendWrongAddress = (data?: { tenant_id: string }) =>
  API.post(`/${INTERNAL}/api/v4/notifications/refusal/wrong_address/`, data);

/* Получение полной ссылки на настройку оповещений для пользователя, перешедшего извне */
export const getQueryUrl = (id: string) =>
  API.get(`/${INTERNAL}/api/v4/notifications/unsubscribe/${id}/`);
